import { useAppSelector } from 'src/app/store/hooks';

export function useIsEditingTrip() {
  const selectedTrip = useAppSelector((state) => state.addATrip.selectedTrip);
  return !!selectedTrip?.id;
}
